module.exports = __webpack_public_path__ + "img/popup-bg-invited.b286966.png";